import Dexie, { Table } from 'dexie';
import { globalConf } from 'src/GlobalConf';

export interface ArticuloDB {
    id?: number
    articulos: string
}
export interface ClienteDB {
    id?: number
    clientes: string
}
export interface ProveedorDB {
    id?: number
    proveedores: string
}
export interface PedidoDB {
    id?: number
    pedidos: string
}
export interface FacturaDB {
    id?: number
    facturas: string
}

export interface AlbaranDB {
    id?: number
    albaranes: string
}

export interface PresupuestoDB {
    id?: number
    presupuestos: string
}

export class AppDB extends Dexie {


    dbArticulos!: Table<ArticuloDB>
    dbArticulosRecientes!: Table<ArticuloDB>

    dbClientes!: Table<ClienteDB>
    dbClientesRecientes!: Table<ClienteDB>

    dbProveedores!: Table<ProveedorDB>
    dbProveedoresRecientes!: Table<ProveedorDB>

    dbPedidosVenta!: Table<PedidoDB>
    dbPedidosCompra!: Table<PedidoDB>

    dbFacturasVenta!: Table<FacturaDB>
    dbFacturasCompra! : Table<FacturaDB>
    dbFacturasSimplificadas! : Table<FacturaDB>

    dbAlbaranesVenta!: Table<AlbaranDB>
    dbAlbaranesCompra!: Table<AlbaranDB>


    dbPresupuestos!: Table<PresupuestoDB>


    constructor() {
        super('Alosuite');
        this.version(globalConf.indexDB_version).stores({
            dbArticulos: 'id++',
            dbArticulosRecientes: 'id++',
            dbClientes: 'id++',
            dbClientesRecientes: 'id++',
            dbPedidosVenta: 'id++',
            dbPedidosCompra: 'id++',
            dbFacturasVenta: 'id++',
            dbFacturasCompra: 'id++',
            dbFacturasSimplificadas: 'id++',
            dbAlbaranesVenta: 'id++',
            dbAlbaranesCompra: 'id++',
            dbPresupuestos: 'id++',
            dbProveedores: 'id++',
            dbProveedoresRecientes: 'id++'
        })
    }

    async resetDatabase() {
        await this.borrarArticulosDB();
        await this.borrarArticulosRecientesDB();
        await this.borrarClientesDB();
        await this.borrarClientesRecientesDB();
        await this.borrarPedidosVentaDB();
        await this.borrarPedidosCompraDB();
        await this.borrarAlbaranesVentaDB();
        await this.borrarAlbaranesCompraDB();
        await this.borrarFacturasVentaDB();
        await this.borrarFacturasCompraDB();
        await this.borrarFacturasSimplificadasDB();
        await this.borrarPresupuestosDB();
        await this.borrarProveedoresDB();
        await this.borrarProveedoresRecientesDB();

        // await db.transaction('rw', 'dbArticulos', () => {
        //     this.dbArticulos.clear();
        // });
        // await db.transaction('rw', 'dbArticulosRecientes', () => {
        //     this.dbArticulos.clear();
        // });
        // await db.transaction('rw', 'dbClientes', () => {
        //     this.dbClientes.clear();
        // });
        // await db.transaction('rw', 'dbClientesRecientes', () => {
        //     this.dbClientesRecientes.clear();
        // });
        // await db.transaction('rw', 'dbPedidos', () => {
        //     this.dbPedidos.clear();
        // });
        // await db.transaction('rw', 'dbFacturas', () => {
        //     this.dbFacturas.clear();
        // });
        // await db.transaction('rw', 'dbAlbaranes', () => {
        //     this.dbAlbaranes.clear();
        // });
        // await db.transaction('rw', 'dbPresupuestos', () => {
        //     this.dbPresupuestos.clear();
        // });
    }

    async deleteDatabase() {
        await db.delete()
    }

    async guardarClientesDB(arrayClientesEnciptado: string) {
        try {
            db.dbClientes.add({
                clientes: arrayClientesEnciptado
            }).then(res => {
                console.log('Clientes almacenados en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar clientes en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar clientes en IndexedDB. Error: ', error);
        }

    }

    async guardarProveedoresDB(arrayProveedoresEnciptado: string) {
        try {
            db.dbProveedores.add({
                proveedores: arrayProveedoresEnciptado
            }).then(res => {
                console.log('Proveedores almacenados en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar Proveedores en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar Proveedores en IndexedDB. Error: ', error);
        }

    }

    async borrarClientesDB() {
        try {
            await db.dbClientes.clear().then(async () => {
                console.log('Limpieza de tabla clientes realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar clientes en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar clientes en IndexedDB. Error: ', error);
        }

    }

    async borrarProveedoresDB() {
        try {
            await db.dbProveedores.clear().then(async () => {
                console.log('Limpieza de tabla proveedores realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar proveedores en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar proveedores en IndexedDB. Error: ', error);
        }

    }

    async borrarClientesRecientesDB() {
        try {
            await db.dbClientesRecientes.clear().then(async () => {
                console.log('Limpieza de tabla clientes recientes realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar clientes recientes en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar clientes en IndexedDB. Error: ', error);
        }

    }

    async borrarProveedoresRecientesDB() {
        try {
            await db.dbProveedoresRecientes.clear().then(async () => {
                console.log('Limpieza de tabla proveedores recientes realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar proveedores recientes en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar proveedores recientes en IndexedDB. Error: ', error);
        }      
    }
    async guardarClientesRecientesDB(clienteRecienteEnciptado) {
        try {
            db.dbClientesRecientes.add({
                clientes: clienteRecienteEnciptado
            }).then(res => {
                console.log('Proveedores recientes almacenado en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar clientes recientse en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar clientes recientes en IndexedDB. Error: ', error);
        }

    }

    async guardarProveedoresRecientesDB(proveedorRecienteEnciptado) {
        try {
            db.dbProveedoresRecientes.add({
                proveedores: proveedorRecienteEnciptado
            }).then(res => {
                console.log('Proveedores recientes almacenado en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar proveedores recientse en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar proveedores recientes en IndexedDB. Error: ', error);
        }

    }

    async guardarArticulosDB(arrayArticulosEnciptado: string) {
        try {
            db.dbArticulos.add({
                articulos: arrayArticulosEnciptado
            }).then(res => {
                console.log('Articulos almacenados en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar articulos en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar articulos en IndexedDB. Error: ', error);
        }

    }

    async borrarArticulosDB() {
        try {
            await db.dbArticulos.clear().then(async () => {
                console.log('Limpieza de tabla articulos realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar articulos en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar articulos en IndexedDB. Error: ', error);
        }

    }

    async borrarArticulosRecientesDB() {
        try {
            await db.dbArticulosRecientes.clear().then(async () => {
                console.log('Limpieza de tabla articulos recientes realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar articulos recientes en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar articulos recientes en IndexedDB. Error: ', error);
        }

    }
    async guardarArticulosRecientesDB(articuloRecienteEnciptado) {
        try {
            db.dbArticulosRecientes.add({
                articulos: articuloRecienteEnciptado
            }).then(res => {
                console.log('Articulo reciente almacenado en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar articulo reciente en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar articulo reciente en IndexedDB. Error: ', error);
        }

    }

    async guardarPedidosVentaDB(arrayPedidosEnciptado: string) {
        console.log('guardarPedidosDB entrando ');

        try {
            db.dbPedidosVenta.add({
                pedidos: arrayPedidosEnciptado
            }).then(res => {
                console.log('Pedidos almacenados en IndexedDB. ', res);
            }).catch(e => {
                console.log('ERROR: Error al guardar pedidos en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar pedidos en IndexedDB. Error: ', error);
        }

    }

    async borrarPedidosVentaDB() {
        try {
            await db.dbPedidosVenta.clear().then(async () => {
                console.log('Limpieza de tabla pedidos realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar pedidos en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar pedidos en IndexedDB. Error: ', error);
        }
    }

    async guardarPedidosCompraDB(arrayPedidosEnciptado: string) {
        try {
            db.dbPedidosCompra.add({
                pedidos: arrayPedidosEnciptado
            }).then(res => {
                console.log('Pedidos almacenados en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar pedidos compra en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar pedidos compra en IndexedDB. Error: ', error);
        }

    }

    async borrarPedidosCompraDB() {
        try {
            await db.dbPedidosCompra.clear().then(async () => {
                console.log('Limpieza de tabla pedidos compra realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar pedidos compra en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar pedidos compra en IndexedDB. Error: ', error);
        }
    }

    async guardarFacturasVentaDB(arrayFacturasEnciptado: string) {
        try {
            db.dbFacturasVenta.add({
                facturas: arrayFacturasEnciptado
            }).then(res => {
                console.log('Facturas almacenadas en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar facturas en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar facturas en IndexedDB. Error: ', error);
        }

    }

    async borrarFacturasVentaDB() {
        try {
            await db.dbFacturasVenta.clear().then(async () => {
                console.log('Limpieza de tabla facturas realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar facturas en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar facturas en IndexedDB. Error: ', error);
        }
    }

    async guardarFacturasSimplificadasDB(arrayFacturasEnciptado: string) {
        try {
            db.dbFacturasSimplificadas.add({
                facturas: arrayFacturasEnciptado
            }).then(res => {
                console.log('Facturas simplificadas almacenadas en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar facturas simplificadas en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar facturas simplificadas en IndexedDB. Error: ', error);
        }

    }

    async borrarFacturasSimplificadasDB() {
        try {
            await db.dbFacturasSimplificadas.clear().then(async () => {
                console.log('Limpieza de tabla facturas simplificadas realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar facturas simplificadas en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar facturas simplificadas en IndexedDB. Error: ', error);
        }
    }


    async guardarFacturasCompraDB(arrayFacturasEnciptado: string) {
        try {
            db.dbFacturasCompra.add({
                facturas: arrayFacturasEnciptado
            }).then(res => {
                console.log('Facturas almacenadas en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar facturas compra en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar facturas compra en IndexedDB. Error: ', error);
        }

    }

    async borrarFacturasCompraDB() {
        try {
            await db.dbFacturasCompra.clear().then(async () => {
                console.log('Limpieza de tabla facturas realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar facturas compra en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar facturas compra en IndexedDB. Error: ', error);
        }
    }

    async guardarAlbaranesVentaDB(arrayAlbaranesEnciptado: string) {
        try {
            db.dbAlbaranesVenta.add({
                albaranes: arrayAlbaranesEnciptado
            }).then(res => {
                console.log('Albaranes almacenadas en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar albaranes en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar albaranes en IndexedDB. Error: ', error);
        }

    }

    async borrarAlbaranesVentaDB() {
        try {
            await db.dbAlbaranesVenta.clear().then(async () => {
                console.log('Limpieza de tabla albaranes realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar albaranes en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar albaranes en IndexedDB. Error: ', error);
        }
    }

    async guardarAlbaranesCompraDB(arrayAlbaranesEnciptado: string) {
        try {
            db.dbAlbaranesVenta.add({
                albaranes: arrayAlbaranesEnciptado
            }).then(res => {
                console.log('Albaranes almacenadas en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar albaranes compra en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar albaranes compra en IndexedDB. Error: ', error);
        }

    }

    async borrarAlbaranesCompraDB() {
        try {
            await db.dbAlbaranesCompra.clear().then(async () => {
                console.log('Limpieza de tabla albaranes realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar albaranes compra en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar albaranes compra en IndexedDB. Error: ', error);
        }
    }

    async guardarPresupuestosDB(arrayPresupuestosEnciptado: string) {
        try {
            db.dbPresupuestos.add({
                presupuestos: arrayPresupuestosEnciptado
            }).then(res => {
                console.log('Presupuestos almacenadas en IndexedDB. ');
            }).catch(e => {
                console.log('ERROR: Error al guardar presupuestos en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al guardar presupuestos en IndexedDB. Error: ', error);
        }

    }

    async borrarPresupuestosDB() {
        try {
            await db.dbPresupuestos.clear().then(async () => {
                console.log('Limpieza de tabla presupuestos realizada.');
            }).catch(e => {
                console.log('ERROR: Error al limpiar presupuestos en IndexedDB. Error: ', e);
            })
        } catch (error) {
            console.log('ERROR: Error al limpiar presupuestos en IndexedDB. Error: ', error);
        }
    }
}

export const db = new AppDB();